import { Grid } from "@mui/material"

export default function LayoutWrapper({ children, spacing = 2, style = {} }) {
	return (
		<Grid className="m-b-3-theme" container spacing={spacing} data-testid={"layout-wrapper"} style={{ ...style }}>
			{children}
		</Grid>
	)
}
